import { compareFontVariants } from './compareFontVariants';
import { DEFAULT_FONT_WEIGHT, parseFontVariant } from './parseFontVariant';

/** Prefer the regular upright variant, otherwise the first available variant. */
export const getDefaultFontVariant = (variants: string[]) => {
  if (variants.length === 0) {
    return undefined;
  }

  const regularVariant = variants.find((variant) => {
    const { fontStyle, fontWeight } = parseFontVariant(variant);

    return fontStyle === 'normal' && fontWeight === DEFAULT_FONT_WEIGHT;
  });

  if (regularVariant) {
    return regularVariant;
  }

  return [...variants].sort(compareFontVariants)[0];
};
